import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=5272e6d8&scoped=true"
import script from "./AccountMenu.vue?vue&type=script&lang=js"
export * from "./AccountMenu.vue?vue&type=script&lang=js"
import style0 from "./AccountMenu.vue?vue&type=style&index=0&id=5272e6d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5272e6d8",
  null
  
)

export default component.exports